<template>
	<div class="bg5 p4">
		<core-form-input
			class="mb4"
			componentName="j-base-input-text"
			name="name"
			id="name"
			:label="$t('name_of_template')"
			:validationErrors="errors"
			v-model="name"
			v-validate="{ required: true }"
		/>
		<core-form-input
			class="mb4"
			componentName="j-base-input-long-text"
			name="description"
			id="description"
			:label="$t('description')"
			v-model="description"
		/>

		<div class="flex xs-12 xs-right">
			<j-button @click="createFunctionTemplate">{{ $t("create") }}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton/"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	data() {
		return {
			name: null,
			description: null
		}
	},

	methods: {
		async createFunctionTemplate() {
			const query = gql`
				mutation createFunctionTemplate($input: createFunctionTemplateInput!) {
					createFunctionTemplate(input: $input) {
						status
						errors
					}
				}
			`
			const variables = {
				input: {
					name: this.name,
					description: this.description
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.createFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.createFunctionTemplate?.errors ||
							res?.data?.createFunctionTemplate?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			this.$emit("created:functionTemplate")
		}
	}
}
</script>
